import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import window from 'window-or-global';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

function YouTube() {
	window.tinymce.plugins.Autoconvert.autoConvert.addHandler((uri, node, done) => {
		if (uri.host.match('.*youtu.be.*')) {
			const vidId = uri.path.substr(1);
			const newurl = `http://youtube.com/watch?v=${vidId}`;
			done($(node).attr('href', newurl).html(newurl));
		} else {
			done();
		}
	});
}

export default function () {
	bind('init.rte', YouTube);
}
